/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 33,
  image: "default-changelog-v2.png",
  title: "DOCS Improvments",
  shortDescription: "We have added guides for deploying popular server frameworks, and marketplace apps.",
  description: "We have added guides for deploying popular server frameworks, and marketplace apps.",
  date: "June 9th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Storage", "SDK", "Browser-Upload", "FVM"]
};
export const content = `
## Docs Improvments

We have added Server Guides for popular frameworks. These guides aim to provide comprehensive instructions and resources for developers working with these server technologies. It includes:

- GO
- Express
- Ruby on Rails
- Rust

We have also added a variety of Marketplace App Guides. These guides offer valuable insights and instructions for building applications. It includes:

- Mongodb
- Redis
- PostgreSQL
- MySQL
- Grafana
- Vault
- IPFS
- Substrate
- Stride
- Hypersign
- Kyve
- Reef
- Sui
- Mantle DTL
- Mantle Verifier
- Drupal
- Deso
- Massbit Gateway
- Arbitrum One
- Filecoin

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
